import { Component, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { Config, Nav, Platform, LoadingController, AlertController } from 'ionic-angular';

import { FirstRunPage } from '../pages';
import { Settings } from '../providers';
import { Storage } from '@ionic/storage';
import { User } from '../providers';
import { Push, PushObject, PushOptions } from '@ionic-native/push';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage = FirstRunPage;

  @ViewChild(Nav) nav: Nav;

  pages: any[] = [
    { title: 'Events', component: 'ListMasterPage', icon: 'md-calendar', id_title: 'EVENTS'  },
    { title: 'MyEvents', component: 'MyeventsPage', icon: 'md-paper', id_title: 'MYEVENTS'  },
    { title: 'Trainings', component: 'TrainingsPage', icon: 'school', id_title: 'TRAININGS'  },
    { title: 'TraiReferenceletternings', component: 'ReferenceletterPage', icon: 'mail', id_title: 'REFERENCELETTER'  },
    { title: 'Settings', component: 'SettingsPage', icon: 'settings', id_title: 'SETTINGS_TITLE'  },
    { title: 'Contact', component: 'ContactPage', icon: 'information-circle', id_title: 'CONTACT'  },
    { title: 'Logout', component: 'LogoutPage', icon: 'exit', id_title: 'LOGOUT'  },
  ]

  constructor(private translate: TranslateService, public platform: Platform, settings: Settings, private config: Config, private statusBar: StatusBar,
    private storage: Storage,
    private splashScreen: SplashScreen,
    public user: User,
    public push: Push,
    public loadingCtrl: LoadingController,
    public alertCtrl:AlertController) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.initPushNotification();
      this.storage.get('_settings')
      .then((settings) => {
        if(settings==null){
          this.initTranslate();
        }else{
          var lang = 'en';
          if (settings.language == 'en') {
            lang = 'fr';
          }
          this.translate.setDefaultLang(lang);
          this.translate.use(settings.language);
        }
      })
    });
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();

    if (browserLang) {
      if (browserLang === 'zh') {
        const browserCultureLang = this.translate.getBrowserCultureLang();

        if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
          this.translate.use('zh-cmn-Hans');
        } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
          this.translate.use('zh-cmn-Hant');
        }
      } else {
        this.translate.use(this.translate.getBrowserLang());
      }
    } else {
      this.translate.use('en'); // Set your language here
    }

    this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
      this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  initPushNotification() {
    if (!this.platform.is('cordova')) {
      console.warn('Push notifications not initialized. Cordova is not available - Run in physical device');
      return;
    }
    const options: PushOptions = {
      android: {
        senderID: '554741126490',
        icon: 'icon',
        iconColor: "#A40046"
      },
      ios: {
        alert: 'true',
        badge: false,
        sound: 'true'
      },
      windows: {}
    };
    const pushObject: PushObject = this.push.init(options);

    pushObject.on('registration').subscribe((data: any) => {
      console.log('device token -> ' + data.registrationId);
      //TODO - send device token to server
      this.storage.set('pushid', data.registrationId);
    });

    pushObject.on('notification').subscribe((data: any) => {
      console.log('message -> ' + data.message);

      //if user using app and push notification comes
      if (data.additionalData.foreground) {
        // if application open, show popup
        if (data.additionalData.page == 'birthday') {
          let confirmAlert = this.alertCtrl.create({
            title: this.translate.instant('NEW_NOTIFICATION'),
            message: data.message,
            buttons: [{
              text: this.translate.instant('CLOSE'),
              role: 'cancel'
            }]
          });
          confirmAlert.present();
        } else {
        let buttonhandler = {
          text: this.translate.instant('VIEW'),
          handler: () => {
            //TODO: Your logic here
            if (data.additionalData.page && data.additionalData.id) {
              this.nav.push(data.additionalData.page, { itemid: data.additionalData.id });
            } else if (data.additionalData.page) {
              this.nav.push(data.additionalData.page);
            } else {

            }
            
          }
        };
        
        let confirmAlert = this.alertCtrl.create({
          title: this.translate.instant('NEW_NOTIFICATION'),
          message: data.message,
          buttons: [{
            text: this.translate.instant('IGNORE'),
            role: 'cancel'
          }, buttonhandler]
        });
        confirmAlert.present();
      }
      } else {
        //if user NOT using app and push notification comes
        //TODO: Your logic on click of push notification directly
        //this.nav.push(DetailsPage, { message: data.message });
        if (data.additionalData.page && data.additionalData.id) {
          this.nav.push(data.additionalData.page, { itemid: data.additionalData.id });
        } else if (data.additionalData.page) {
          this.nav.push(data.additionalData.page);
        } else {
          this.nav.setRoot('ListMasterPage');
        }
      }
    });

    pushObject.on('error').subscribe(error => console.error('Error with Push plugin' + error));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts